import { FC } from 'react';
import classNames from 'classnames';
import { FieldWrapper } from 'framework/field/components/FieldWrapper';
import { useFieldTheme } from 'framework/field/hooks/useFieldTheme';
import { Icon } from 'framework/Icon';
import { Label } from 'framework/label';
import { SwitchElement } from 'framework/Switch/elements';
import { useSwitchTheme } from 'framework/Switch/hooks/useSwitchTheme';
import { SwitchProps } from 'framework/Switch/types';

import { EMPTY_FUNCTION } from '../../constants';

import cn from './Switch.module.scss';

export const Switch: FC<SwitchProps> = ({
  label = '',
  information = '',
  height = '32px',
  width = '100%',
  padding = '0px',
  checked = false,
  onClick = EMPTY_FUNCTION,
  disabled = false,
  circle = 20,
  gap = 6,
  left_label = '',
  right_label = '',
  left_icon,
  right_icon,
  theme,
}) => {
  const field_theme = useFieldTheme(theme?.field);
  const switch_theme = useSwitchTheme(theme?.switch);
  const circle_height = circle + gap;
  const circle_width = circle_height * 2;
  return (
    <FieldWrapper
      label={label}
      information={information}
      width={width}
      padding={padding}
      theme={field_theme.general}
    >
      <SwitchElement
        className={classNames('transition', cn.container)}
        data-disabled={disabled}
        aria-checked={checked}
        onClick={() => !disabled && onClick(!checked)}
        theme={{ field: field_theme, switch: switch_theme }}
        style={{ height }}
      >
        <Label label={left_label} theme={field_theme.general} />
        <button
          role="switch"
          className={classNames('transition', cn.button, { [cn.disabled]: disabled })}
          aria-checked={checked}
          aria-label={`${left_icon} or ${right_icon}`}
          data-disabled={disabled}
          style={{ width: circle_width, height: circle_height }}
        >
          {left_icon && (
            <div
              className={classNames(cn.left, { [cn.active]: checked })}
              style={{ width: circle_height, height: circle_height }}
            >
              <Icon icon={left_icon} button />
            </div>
          )}
          <span
            className={classNames('transition', cn.circle)}
            style={{
              width: circle,
              height: circle,
              top: (circle_height - circle) / 2 - 1,
              left: gap / 2 - 1,
              background: field_theme.color.normal,
              transform: `translateX(${checked ? circle_width - circle - gap : 0}px)`,
            }}
          />
          {right_icon && (
            <div
              className={classNames(cn.right, { [cn.active]: checked })}
              style={{ width: circle_height, height: circle_height }}
            >
              <Icon icon={right_icon} button />
            </div>
          )}
        </button>
        <Label label={right_label} theme={field_theme.general} button />
      </SwitchElement>
    </FieldWrapper>
  );
};
